import { Status, States } from '@sift/resift/models/Status';

// Actions
export const DOMAIN_OPTIONS_FETCH = 'DOMAIN_OPTIONS_FETCH';
export const DOMAIN_OPTIONS_FETCH_SUCCESS = 'DOMAIN_OPTIONS_FETCH_SUCCESS';
export const DOMAIN_OPTIONS_FETCH_ERROR = 'DOMAIN_OPTIONS_FETCH_ERROR';

export const REDIRECT_QUERY_FETCH = 'REDIRECT_QUERY_FETCH';

export const PASSWORD_LOGIN_FETCH = 'PASSWORD_LOGIN_FETCH';
export const PASSWORD_LOGIN_FETCH_SUCCESS = 'PASSWORD_LOGIN_FETCH_SUCCESS';
export const PASSWORD_LOGIN_FETCH_ERROR = 'PASSWORD_LOGIN_FETCH_ERROR';

export const FORGOT_PASSWORD_FETCH = 'FORGOT_PASSWORD_FETCH';
export const FORGOT_PASSWORD_FETCH_SUCCESS = 'FORGOT_PASSWORD_FETCH_SUCCESS';
export const FORGOT_PASSWORD_FETCH_ERROR = 'FORGOT_PASSWORD_FETCH_ERROR';

export const VALIDATE_RESET_TOKEN_FETCH = 'VALIDATE_RESET_TOKEN_FETCH';
export const VALIDATE_RESET_TOKEN_FETCH_SUCCESS = 'VALIDATE_RESET_TOKEN_FETCH_SUCCESS';
export const VALIDATE_RESET_TOKEN_FETCH_ERROR = 'VALIDATE_RESET_TOKEN_FETCH_ERROR';

export const RESET_PASSWORD_FETCH = 'RESET_PASSWORD_FETCH';
export const RESET_PASSWORD_FETCH_SUCCESS = 'RESET_PASSWORD_FETCH_SUCCESS';
export const RESET_PASSWORD_FETCH_ERROR = 'RESET_PASSWORD_FETCH_ERROR';

export const VALIDATE_INVITE_TOKEN_FETCH = 'VALIDATE_INVITE_TOKEN_FETCH';
export const VALIDATE_INVITE_TOKEN_FETCH_SUCCESS = 'VALIDATE_INVITE_TOKEN_FETCH_SUCCESS';
export const VALIDATE_INVITE_TOKEN_FETCH_ERROR = 'VALIDATE_INVITE_TOKEN_FETCH_ERROR';

export const COMPLETE_PASSWORD_INVITE_FETCH = 'COMPLETE_PASSWORD_INVITE_FETCH';
export const COMPLETE_PASSWORD_INVITE_FETCH_SUCCESS = 'COMPLETE_PASSWORD_INVITE_FETCH_SUCCESS';
export const COMPLETE_PASSWORD_INVITE_FETCH_ERROR = 'COMPLETE_PASSWORD_INVITE_FETCH_ERROR';

export const CONFIRM_SUBSCRIPTION_FETCH = 'CONFIRM_SUBSCRIPTION_FETCH';
export const CONFIRM_SUBSCRIPTION_FETCH_SUCCESS = 'CONFIRM_SUBSCRIPTION_FETCH_SUCCESS';
export const CONFIRM_SUBSCRIPTION_FETCH_ERROR = 'CONFIRM_SUBSCRIPTION_FETCH_ERROR';

export const RESOLVE_SUBSCRIPTION_FETCH = 'RESOLVE_SUBSCRIPTION_FETCH';
export const RESOLVE_SUBSCRIPTION_FETCH_SUCCESS = 'RESOLVE_SUBSCRIPTION_FETCH_SUCCESS';
export const RESOLVE_SUBSCRIPTION_FETCH_ERROR = 'RESOLVE_SUBSCRIPTION_FETCH_ERROR';

export function fetchLoginOption(email) {
  return {
    type: DOMAIN_OPTIONS_FETCH,
    payload: {
      data: {
        email,
      },
    },
  };
}

export function loginWithPassword(
  email,
  password,
  setCookies,
  clientId,
  directoryId = null,
  additionalQueryParams,
) {
  return {
    type: PASSWORD_LOGIN_FETCH,
    payload: {
      data: {
        email,
        clientId,
        directoryId,
        password,
        setCookies,
      },
      query: additionalQueryParams,
    },
  };
}

export function forgotPassword(email, clientId, directoryId = null) {
  return {
    type: FORGOT_PASSWORD_FETCH,
    payload: {
      data: {
        email,
        clientId,
        directoryId,
      },
    },
  };
}

export function fetchResetTokenValidation(resetToken, subdomain) {
  return {
    type: VALIDATE_RESET_TOKEN_FETCH,
    payload: {
      query: {
        resetToken,
        subdomain,
      },
    },
  };
}

export function resetPassword(password, passwordConfirm, resetToken, subdomain) {
  return {
    type: RESET_PASSWORD_FETCH,
    payload: {
      data: {
        password,
        passwordConfirm,
        resetToken,
        subdomain,
      },
    },
  };
}

export function fetchInviteTokenValidation(inviteToken, subdomain) {
  return {
    type: VALIDATE_INVITE_TOKEN_FETCH,
    payload: {
      query: {
        inviteToken,
        subdomain,
      },
    },
  };
}

export function submitPasswordInviteToken(inviteToken, password, subdomain) {
  return {
    type: COMPLETE_PASSWORD_INVITE_FETCH,
    payload: {
      data: {
        inviteToken,
        password,
        subdomain,
      },
    },
  };
}

export function preserveRedirectQuery(query, search) {
  return {
    type: REDIRECT_QUERY_FETCH,
    payload: {
      data: {
        query,
        search,
      },
    },
  };
}

export function resolveSubscription(idToken, subscriptionToken) {
  return {
    type: RESOLVE_SUBSCRIPTION_FETCH,
    payload: {
      data: {
        idToken,
        subscriptionToken,
      },
    },
  };
}

export function confirmSubscription(idToken, subscriptionId, companyName) {
  return {
    type: CONFIRM_SUBSCRIPTION_FETCH,
    payload: {
      data: {
        idToken,
        subscriptionId,
        companyName,
      },
    },
  };
}

// TODO: Helper functions for most of these
// Action Handlers
const ACTION_HANDLERS = {
  [DOMAIN_OPTIONS_FETCH]: (state, action) => {
    return {
      ...state,
      status: new Status(States.LOADING),
      error: action.payload.data.message || '',
    };
  },
  [DOMAIN_OPTIONS_FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
      error: action.payload.data.message || '',
      loginDomains: action.payload.data.results,
      email: action.originalPayload.data.email,
      status: new Status(States.NORMAL),
    };
  },
  [DOMAIN_OPTIONS_FETCH_ERROR]: (state, action) => {
    return {
      ...state,
      error: action.payload.data.message,
      status: new Status(States.ERROR),
    };
  },
  [PASSWORD_LOGIN_FETCH]: (state, action) => {
    return {
      ...state,
      status: new Status(States.LOADING),
    };
  },
  [PASSWORD_LOGIN_FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
      passwordLoginResponse: action.payload.data,
      status: new Status(States.NORMAL),
    };
  },
  [PASSWORD_LOGIN_FETCH_ERROR]: (state, action) => {
    return {
      ...state,
      status: new Status(States.ERROR),
    };
  },
  [FORGOT_PASSWORD_FETCH]: (state, action) => {
    return {
      ...state,
      status: new Status(States.LOADING),
    };
  },
  [FORGOT_PASSWORD_FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
    };
  },
  [FORGOT_PASSWORD_FETCH_ERROR]: (state, action) => {
    return {
      ...state,
      status: new Status(States.ERROR),
    };
  },
  [VALIDATE_RESET_TOKEN_FETCH]: (state, action) => {
    return {
      ...state,
      status: new Status(States.LOADING),
    };
  },
  [VALIDATE_RESET_TOKEN_FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
      data: action.payload.data,
      status: new Status(States.NORMAL),
    };
  },
  [VALIDATE_RESET_TOKEN_FETCH_ERROR]: (state, action) => {
    return {
      ...state,
      error: action.payload.error,
      status: new Status(States.ERROR),
    };
  },
  [RESET_PASSWORD_FETCH]: (state, action) => {
    return {
      ...state,
      status: new Status(States.LOADING),
    };
  },
  [RESET_PASSWORD_FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
      status: new Status(States.NORMAL),
    };
  },
  [RESET_PASSWORD_FETCH_ERROR]: (state, action) => {
    return {
      ...state,
      status: new Status(States.ERROR),
    };
  },
  [VALIDATE_INVITE_TOKEN_FETCH]: (state, action) => {
    return {
      ...state,
      status: new Status(States.LOADING),
    };
  },
  [VALIDATE_INVITE_TOKEN_FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
      status: new Status(States.NORMAL),
      isSaml: action.payload.data.isSAML,
      isStandard: action.payload.data.isStandard,
      email: action.payload.data.email,
      companyName: action.payload.data.companyName,
    };
  },
  [VALIDATE_INVITE_TOKEN_FETCH_ERROR]: (state, action) => {
    return {
      ...state,
      status: new Status(States.ERROR),
      error: action.payload.error,
    };
  },
  [COMPLETE_PASSWORD_INVITE_FETCH]: (state, action) => {
    return {
      ...state,
      status: new Status(States.LOADING),
    };
  },
  [COMPLETE_PASSWORD_INVITE_FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
      status: new Status(States.NORMAL),
    };
  },
  [COMPLETE_PASSWORD_INVITE_FETCH_ERROR]: (state, action) => {
    return {
      ...state,
      status: new Status(States.ERROR),
    };
  },
  [REDIRECT_QUERY_FETCH]: (state, action) => {
    return {
      ...state,
      query: action.payload.data.query,
      search: action.payload.data.search,
    };
  },
  [CONFIRM_SUBSCRIPTION_FETCH]: state => {
    return {
      ...state,
      subscriptionConfirmationStatus: new Status(States.LOADING),
    };
  },
  [CONFIRM_SUBSCRIPTION_FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
      subscriptionConfirmationStatus: new Status(States.NORMAL),
      subscriptionConfirmationData: action.payload.data,
    };
  },
  [CONFIRM_SUBSCRIPTION_FETCH_ERROR]: (state, action) => {
    return {
      ...state,
      subscriptionConfirmationStatus: new Status(States.ERROR),
      error: action.payload.error,
    };
  },
  [RESOLVE_SUBSCRIPTION_FETCH]: state => {
    return {
      ...state,
      status: new Status(States.LOADING),
    };
  },
  [RESOLVE_SUBSCRIPTION_FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
      status: new Status(States.NORMAL),
      subscriptionData: action.payload.data,
    };
  },
  [RESOLVE_SUBSCRIPTION_FETCH_ERROR]: (state, action) => {
    return {
      ...state,
      status: new Status(States.ERROR),
      error: action.payload.error,
    };
  },
};

// Reducer
export const initialState = {
  status: new Status(States.NORMAL),
  error: '',
  loginDomains: [],
  passwordLoginResponse: {},
  email: '',
  data: {},
  loginCredentials: {},
  query: '',
  search: '',
  subscriptionData: {},
  subscriptionConfirmationStatus: new Status(States.NORMAL),
  subscriptionConfirmationData: {},
};

export default function LoginReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
